export default "__VITE_ASSET__3a47dbbe__"